import React from 'react';
import { TextFieldProps } from '@mui/material';
import * as Styled from './MBTextField.styles';

type MBTextFieldProps = TextFieldProps & {
  isRounded?: boolean;
  disableAutofillStyles?: boolean;
};

const MBTextField: React.FC<MBTextFieldProps> = (props) => {
  const isStandardVariant = props.variant === 'standard';
  return (
    <Styled.TextField
      {...props}
      label={isStandardVariant ? props.label : undefined} // you will have to use the placeholder instead if you want to see somekind of input label
      // placeholder={isStandardVariant ? undefined : props.placeholder} // dont define placeholder if there is a label when you are on standard variant
      InputLabelProps={{ shrink: isStandardVariant ? undefined : true }}
    />
  );
};

export default MBTextField;
